import React, { useState } from 'react';
import DataSource from './DataSource';
import TransformationComponent from './TransformationComponent';
import Model from './Model';
import Visualization from './Visualization';

function SidebarContent({ toggleSidebar,selectedWidget, visualizationData,setVisualizationData,setSheetData,modelInputData,sheetData,transformData,setTransformData,nodeId,setNodeId,updateNodeWithSourceData,updateTransformNodeData }) {
  // You can add your configuration options here based on the selectedWidget
  // For example, if selectedWidget is 'Data Source', show options specific to that widget

  // Example of conditional rendering based on selectedWidget
  
  return (
    <div>
   
      {selectedWidget === 'Data Source' && (
        <div>
          <DataSource toggleSidebar={toggleSidebar} setSheetData={setSheetData} nodeId={nodeId} setNodeId={setNodeId} updateNodeWithSourceData={updateNodeWithSourceData}/>
        </div>
      )}
      {selectedWidget === 'Transform' && (
        <TransformationComponent data={transformData} updateTransformNodeData={updateTransformNodeData} nodeId={nodeId}/> 
      )}
      {selectedWidget === 'Model' && (
        <Model modelInputData={modelInputData} toggleSidebar={toggleSidebar} setVisualizationData={setVisualizationData}/> 
      )}
      {selectedWidget === 'Visualization' && (
        <Visualization visualizationData={visualizationData}/> 
      )}
    </div>
  );
}

export default SidebarContent;
